(function () {
  'use strict';
  if (window.__GS_JA_WISHLIST_REPAIR_V12__) return;
  window.__GS_JA_WISHLIST_REPAIR_V12__ = true;
  if (String(document.documentElement.lang || '').toLowerCase().indexOf('ja') !== 0) return;

  var CARD = '.wishlist-storefront-page__card';
  var TITLE = '.wishlist-storefront-page__card-title';
  var IMAGE = '.wishlist-storefront-page__card-image';
  var PLACEHOLDER = '.wishlist-storefront-page__card-placeholder';
  var ACTIONS = '.wishlist-storefront-page__card-actions';
  var PREVIEW = ['preview_theme_id', 'pb', '_fd', '_sc'];
  var queued = false;

  function text(value) { return String(value == null ? '' : value).trim(); }
  function productId(value) { return text(value).replace(/^gid:\/\/shopify\/Product\//i, ''); }
  function variantId(value) { return text(value).replace(/^gid:\/\/shopify\/ProductVariant\//i, ''); }
  function handle(value) {
    var result = text(value).toLowerCase();
    try { result = decodeURIComponent(result); } catch (_) {}
    return result.replace(/^\/+|\/+$/g, '');
  }
  function handleFromUrl(value) {
    try {
      var match = new URL(text(value), location.origin).pathname.match(/\/products\/([^/?#]+)/i);
      return match ? handle(match[1]) : '';
    } catch (_) { return ''; }
  }
  function withPreview(url) {
    var current = new URL(location.href);
    PREVIEW.forEach(function (key) {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    return url;
  }
  function productUrl(product) {
    var value = handle(product && product.handle);
    if (!value) return '';
    var url = withPreview(new URL('/products/' + encodeURIComponent(value), location.origin));
    return url.pathname + url.search + url.hash;
  }
  function productImage(product) {
    var value = product && Array.isArray(product.images) ? product.images[0] : null;
    if (typeof value === 'string') return value;
    if (value && value.src) return value.src;
    if (product && product.image && product.image.src) return product.image.src;
    return '';
  }
  function index(products) {
    var byId = new Map();
    var byHandle = new Map();
    var byVariant = new Map();
    products.forEach(function (product) {
      var id = productId(product && product.id);
      var productHandle = handle(product && product.handle);
      if (id) byId.set(id, product);
      if (productHandle) byHandle.set(productHandle, product);
      (product && Array.isArray(product.variants) ? product.variants : []).forEach(function (variant) {
        var idValue = variantId(variant && variant.id);
        if (idValue) byVariant.set(idValue, product);
      });
    });
    return { byId: byId, byHandle: byHandle, byVariant: byVariant };
  }
  function feed(path) {
    var url = withPreview(new URL(path, location.origin));
    url.searchParams.set('limit', '250');
    return fetch(url.href, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error(path + ': ' + response.status);
        return response.json();
      })
      .then(function (payload) { return payload && Array.isArray(payload.products) ? payload.products : []; });
  }
  function catalogs() {
    return Promise.allSettled([feed('/products.json'), feed('/en/products.json')]).then(function (results) {
      var japanese = results[0].status === 'fulfilled' ? results[0].value : [];
      var english = results[1].status === 'fulfilled' ? results[1].value : [];
      if (!japanese.length) throw new Error('Japanese catalog unavailable');
      return { ja: index(japanese), en: index(english) };
    });
  }
  function cardFor(title) {
    if (!(title instanceof Element)) return null;
    var direct = title.closest(CARD);
    if (direct) return direct;
    var body = title.closest('.wishlist-storefront-page__card-body');
    return body && body.parentElement ? body.parentElement : null;
  }
  function cardId(card) {
    var node = card.matches('[data-product-id]') ? card : card.querySelector('[data-product-id]');
    return productId(node && node.getAttribute('data-product-id'));
  }
  function cardVariant(card) {
    var input = card.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"][value]');
    return variantId(input && input.value);
  }
  function cardHandle(card, title) {
    var titleValue = handle(title && title.textContent);
    if (/^[a-z0-9]+(?:-[a-z0-9]+)+$/.test(titleValue)) return titleValue;
    var link = card.querySelector('a[href*="/products/"]');
    var fromLink = link ? handleFromUrl(link.getAttribute('href')) : '';
    if (fromLink) return fromLink;
    var node = card.querySelector('[data-product-handle],[data-handle]');
    return handle(
      card.getAttribute('data-product-handle') || card.getAttribute('data-handle') ||
      (node && (node.getAttribute('data-product-handle') || node.getAttribute('data-handle'))) || ''
    );
  }
  function resolve(card, title, maps) {
    var id = cardId(card);
    var variant = cardVariant(card);
    var productHandle = cardHandle(card, title);
    if (id && maps.ja.byId.has(id)) return maps.ja.byId.get(id);
    if (variant && maps.ja.byVariant.has(variant)) return maps.ja.byVariant.get(variant);
    if (productHandle && maps.ja.byHandle.has(productHandle)) return maps.ja.byHandle.get(productHandle);
    var english = (id && maps.en.byId.get(id)) || (variant && maps.en.byVariant.get(variant)) || (productHandle && maps.en.byHandle.get(productHandle));
    return english ? maps.ja.byId.get(productId(english.id)) || null : null;
  }
  function updateImage(card, product) {
    var src = productImage(product);
    if (!src) return;
    var host = card.querySelector(IMAGE);
    var placeholder = card.querySelector(PLACEHOLDER);
    var img = host && host.tagName === 'IMG' ? host : card.querySelector(IMAGE + ' img');
    if (!img) {
      img = document.createElement('img');
      img.className = 'gs-wishlist-restored-image';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.style.cssText = 'display:block;width:100%;height:100%;object-fit:cover;';
      var target = placeholder || host;
      if (target) { target.textContent = ''; target.appendChild(img); }
    }
    if (!img) return;
    img.src = src;
    img.alt = text(product.title);
    if (placeholder) placeholder.setAttribute('aria-label', text(product.title));
  }
  function updateLinks(card, product) {
    var href = productUrl(product);
    if (!href) return;
    var titleNode = card.querySelector(TITLE);
    var imageNode = card.querySelector(IMAGE);
    card.querySelectorAll('a[href]').forEach(function (link) {
      if (link.closest(ACTIONS)) return;
      var current = text(link.getAttribute('href'));
      if (/\/products\//i.test(current) || (titleNode && link.contains(titleNode)) || (imageNode && link.contains(imageNode))) link.href = href;
    });
  }
  function hydrate(title, maps) {
    var card = cardFor(title);
    if (!card) return;
    var product = resolve(card, title, maps);
    if (!product) return;
    title.textContent = text(product.title);
    updateImage(card, product);
    updateLinks(card, product);
    card.setAttribute('data-gs-ja-wishlist-repaired', 'true');
  }
  function scan(maps) {
    Array.from(document.querySelectorAll(TITLE)).forEach(function (title) { hydrate(title, maps); });
  }
  function queue(maps) {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(maps); });
  }

  catalogs().then(function (maps) {
    scan(maps);
    [300, 1000, 2500].forEach(function (delay) { setTimeout(function () { scan(maps); }, delay); });
    document.addEventListener('shopify:section:load', function () { queue(maps); });
    new MutationObserver(function () { queue(maps); }).observe(document.body, { childList: true, subtree: true });
  }).catch(function (error) {
    console.warn('Guiding Stones Japanese wishlist repair:', error.message);
  });
})();
